import { EditorState, ContentState, convertFromRaw } from 'draft-js'

export const prepareSettingForInsert = (
  patient,
  convoPatient,
  newConvo,
  selectedTemplate,
  practiceName,
  isEmail,
) => {
  const templateCopy = JSON.parse(JSON.stringify(selectedTemplate)) // Create deep copy so we're not mutating the original template
  const templateRawState = templateCopy.body.rawState
  let fullnameArr
  if (convoPatient) {
    fullnameArr = convoPatient.reduce(
      (prev, curr) => [
        ...prev,
        { ...curr, full_name: `${curr.first_name} ${curr.last_name}` },
      ],
      [],
    )
  }

  const hasSubjectText = templateCopy.subject ? templateCopy.subject.text : null

  const firstName =
    Object.keys(patient).length !== 0
      ? patient.first_name
      : getPatientNames(convoPatient, 'first_name')

  const lastName =
    Object.keys(patient).length !== 0
      ? patient.last_name
      : getPatientNames(convoPatient, 'last_name')

  const fullName =
    Object.keys(patient).length !== 0
      ? `${patient.first_name} ${patient.last_name}`
      : getPatientNames(fullnameArr, 'full_name')

  const data = {
    patient_first_name: firstName,
    patient_last_name: lastName,
    patient_full_name: fullName,
    practice_name: practiceName,
  }

  templateRawState.blocks.forEach(block => {
    if (block.text) {
      block.text = replaceMentions(block.text, data)
    }
  })

  const bodyState = EditorState.createWithContent(
    convertFromRaw(templateRawState),
  )
  const subjectState = isEmail
    ? EditorState.createWithContent(
        ContentState.createFromText(
          newConvo && hasSubjectText
            ? templateCopy.subject.text
            : templateCopy.template_name,
        ),
      )
    : null

  return { bodyState, subjectState }
}

function getPatientNames(patients, name) {
  let arr = []
  if (patients.length > 1) {
    patients.forEach(item => {
      arr.push(item[name])
    })
    const last = arr.pop()
    return `${arr.join(', ')} and ${last}`
  } else {
    if (patients.length && patients[0][name]) {
      arr.push(patients[0][name])
      return arr
    } else {
      return '** NO NAME **'
    }
  }
}

function replaceMentions(str, data) {
  const regEx = new RegExp(Object.keys(data).join('|'), 'gi')
  return str.replace(regEx, matched => {
    return data[matched]
  })
}



// WEBPACK FOOTER //
// ./src/components/Messages/MessagesEditor/utils.js